module.exports = __webpack_public_path__ + "img/2.3384a96d.jpg";